import { CalendarOutlined } from "@ant-design/icons";

import { useTableFilterIconColor } from "@/modules/table-filter";

const CalendarIcon = (filtered) => {
  const color = useTableFilterIconColor(filtered);

  return <CalendarOutlined style={{ color }} />;
};

export default CalendarIcon;
